import API from '../Utils/API';

export const getOrganizationUsers = (url) => (dispatch) => {
  dispatch({ type: 'GET_ORGANIZATION_USER_REQUEST' });
  API.get(url)
    .then((response) => {
      dispatch({
        type: 'GET_ORGANIZATION_USER_SUCCESS',
        payload: response.data,
      });
    })
    .catch((error) => {
      try {
        dispatch({
          type: 'GET_ORGANIZATION_USER_FAILURE',
          payload: error.response.data,
        });
      } catch {}
    });
};
